export default __webpack_public_path__ + "static/media/header-visu5.0ec6d1f2.jpg";